<div
  class="backimage bg-cover bg-center w-full xl:max-h-[800px] text-white font-sans mt-6 py-12 px-4 md:px-8 lg:px-20 relative overflow-hidden">
  <!-- Theme color Overlay -->
  <div class="absolute inset-0" style="
      background: linear-gradient(
        180deg,
        rgba(10, 14, 31, 0.8) 0%,
        rgba(27, 34, 59, 0.8) 50%,
        rgba(10, 14, 31, 0.8) 100%
      );
    "></div>

  <!-- Heading -->
<div class="relative z-10 text-center max-w-3xl mx-auto px-4">
    <h4 class="text-[#19E4E0] uppercase tracking-wide font-libre font-bold text-[18px] leading-[27px]">
      <span class="text-[#19E4E0] font-semibold uppercase tracking-wide border-b-2 border-[#19E4E0]">customer</span>
      <span class="text-white ml-2">Feedback</span>
    </h4>

    <h2 class="text-2xl md:text-4xl font-bold mt-2">
      Loved by our community worldwide
    </h2>
    <p class="text-gray-400 mt-4 text-sm md:text-base">
      Discover why players love our gaming hub! Read genuine feedback from our
      community and see how we create an exciting, secure, and fun social arcade
      experience for everyone.
    </p>
  </div>

  <!-- Feedback Cards -->
  <div
    class="relative z-10 grid grid-cols-1 xs:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-3 xs:gap-4 md:gap-6 lg:gap-8 mt-8 xs:mt-10 md:mt-14 place-items-center">
    <div *ngFor="let item of feedbacks"
      class="relative w-full max-w-[280px] xs:w-[90%] sm:w-[280px] md:w-[300px] lg:w-[323px] h-[250px] xs:h-[280px] md:h-[320px] lg:h-[350px]">
      <!-- SVG Shape -->
      <!-- SVG Shape -->
      <svg class="absolute inset-0 w-full h-full" viewBox="0 0 323 350" xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="xMidYMid meet">
        <!-- Background path (solid fill only) -->
        <path
          d="M18.5 22.5L36.0411 7.60659C41.8248 2.69589 49.1653 0 56.7525 0H271.13C280.27 0 288.974 3.90873 295.047 10.7404L305.5 22.5L313.944 31.1851C319.751 37.1583 323 45.1607 323 53.4916V296.976C323 304.728 320.187 312.215 315.082 318.049L305.5 329L294.958 340.069C288.918 346.411 280.543 350 271.786 350H56.1421C48.9265 350 41.9226 347.561 36.2675 343.08L20.4377 330.536C19.1478 329.513 17.9387 328.393 16.8211 327.185L8.50882 318.199C3.0385 312.285 0 304.525 0 296.469V54.0123C0 45.3734 3.4929 37.1015 9.68464 31.0771L18.5 22.5Z"
          fill="#1B223B" />

        <!-- Shadow path (filter applied) -->
        <g filter="url(#filter0_i)">
          <path
            d="M18.5 22.5L36.0411 7.60659C41.8248 2.69589 49.1653 0 56.7525 0H271.13C280.27 0 288.974 3.90873 295.047 10.7404L305.5 22.5L313.944 31.1851C319.751 37.1583 323 45.1607 323 53.4916V296.976C323 304.728 320.187 312.215 315.082 318.049L305.5 329L294.958 340.069C288.918 346.411 280.543 350 271.786 350H56.1421C48.9265 350 41.9226 347.561 36.2675 343.08L20.4377 330.536C19.1478 329.513 17.9387 328.393 16.8211 327.185L8.50882 318.199C3.0385 312.285 0 304.525 0 296.469V54.0123C0 45.3734 3.4929 37.1015 9.68464 31.0771L18.5 22.5Z"
            fill="#1B223B" />
        </g>

        <defs>
          <filter id="filter0_i" x="0" y="0" width="323" height="354" filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB">
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="2" />
            <feComposite in2="SourceAlpha" operator="arithmetic" k2="-1" k3="1" />
            <feColorMatrix type="matrix" values="0 0 0 0 0.0989876
                0 0 0 0 0.895192
                0 0 0 0 0.88017
                0 0 0 1 0" />
            <feBlend mode="normal" in2="shape" result="effect1_innerShadow" />
          </filter>
        </defs>
      </svg>

      <!-- Card Content -->
      <div
        class=" relative z-10 flex flex-col justify-center h-[calc(100%_-_10px)] text-white px-4 py-6 sm:px-5 sm:py-7 md:px-6 md:py-8 lg:px-8 lg:py-10">
        <!-- Feedback Text (Centered) -->
        <div class="flex items-center justify-center lg:pt-2">
          <p
            class=" text-[#A6B1C2] text-[10px] sm:text-[8px] md:text-[14px] leading-normal text-justify break-words overflow-hidden line-clamp-6 sm:line-clamp-none">
            {{ item.text }}
          </p>
        </div>

        <!-- Divider Line -->
        <div class="w-full mx-auto h-[1px] bg-[#A6B1C2] opacity-80 my-2 xs:my-3 sm:my-4 md:my-4"></div>

        <!-- User Info -->
        <div class="flex items-center justify-start space-x-2 sm:space-x-3">
          <div
            class="w-7 h-7 xs:w-8 xs:h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 overflow-hidden rounded-lg flex items-center justify-center ">
            <img *ngIf="item.img" [src]="item.img" alt="avatar" class="w-full h-full object-cover rounded-lg" />
            <span *ngIf="!item.img" class="text-xs sm:text-sm">👤</span>
          </div>
          <div class="text-start ">
            <h5 class="font-semibold text-white text-[10px] xs:text-[12px] sm:text-[15px] md:text-[20px]">
              {{ item.name }}
            </h5>
            <p class="text-[#19E4E0] text-[8px] xs:text-[10px] sm:text-[13px] md:text-[14px]">
              {{ item.role }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Slider Navigation (hidden on mobile) -->
  <div class="slider-nav relative justify-around items-center mt-10 md:mt-14 hidden md:flex">
    <button (click)="previousSlide()"
      class="relative z-10 w-10 md:w-12 h-10 md:h-12 rounded-full border-2 border-[#19E4E0] flex items-center justify-center text-[#19E4E0] bg-[#19E4E0]/10 transition-all duration-300">
      <svg class="w-5 h-5 md:w-6 md:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
      </svg>
    </button>

    <div class="absolute inset-x-[6rem] md:inset-x-[15rem] flex items-center pointer-events-none z-0">
      <div class="flex-1 h-[1px] md:h-[2px] bg-[#19E4E0] opacity-50"></div>
    </div>

    <div class="relative z-20 flex items-center space-x-4 md:space-x-6 mx-6 md:mx-8 -mt-1">
      <button *ngFor="let dot of getDots(); let i = index" (click)="goToSlide(i)"
        class="relative w-8 h-8 md:w-10 md:h-10 lg:w-[2.5rem] lg:h-[2.5rem] rounded-full border-2 flex items-center justify-center bg-[#101726] transition-all duration-300 border-[#19E4E0]">
        <span *ngIf="i === currentSlide"
          class="w-3 h-3 md:w-4 md:h-4 lg:w-[1.5rem] lg:h-[1.5rem] rounded-full bg-[#19E4E0]"></span>
      </button>
    </div>

    <button (click)="nextSlide()"
      class="relative z-10 w-10 md:w-12 h-10 md:h-12 rounded-full border-2 border-[#19E4E0] flex items-center justify-center text-[#19E4E0] bg-[#19E4E0]/10 transition-all duration-300">
      <svg class="w-5 h-5 md:w-6 md:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
      </svg>
    </button>
  </div>
</div>
